// Packages
import { Component } from "react";
import { Link } from "react-router-dom";

// Views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";
import MaterialTable from "material-table";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";

// Assets
import backArrow from "../../assets/images/backArrow.png";

// Services
import userService from "../../services/user.service";

const columns = [
  { title: "id", field: "id", hidden: true },
  {
    title: "ATHLETE NAME",
    field: "firstName",
    // onClick: () => <Link to={`/SuperAdminAthlets`} className="txt-blue"  />
    render: (row) => (
      <Link to={`/schoolnamescreen/${row.id}`}>
        <div className="link-blue" key={row.id}>
          {row.schoolName}
        </div>
      </Link>
    ),
  },
  {
    title: "EMAIL",
    field: "email",
    type: "date",
    dateSetting: { locale: "en-US" },
  },
  { title: "SCHOOLS", field: "state" },
  { title: "POSITION PLAYED", field: "country" },
  { title: "GROUP", field: "phoneNumber" },
  {
    title: "GRAD YEAR",
    field: "status",
    render: (row) => <div>{row.status ? "Active" : "Inactive"}</div>,
  },
  {
    render: (rowData) => (
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
      >
        <MoreVertIcon />
      </IconButton>
    ),
  },
];

class Schools extends Component {
  constructor(props) {
    super(props);
    this.state = {
      AllAthleteList: [],
    };
  }
  componentDidMount() {
    this.getSchoolData();
  }
  //   getElements() {
  //     let arr = [];
  //     Object.keys(this.state.checkids).forEach(function(element, index) {
  //        arr.push(
  //          <Checkbox
  //             key={index}
  //             id={element}
  //             checked={this.state.checkids[element]}
  //             onCheck={this.handleCheck.bind(this)}
  //          />
  //        );
  //     }, this)
  //     return arr;
  //  }
  getSchoolData() {
    userService
      .getAllAthlete()
      .then((response) => {
        console.log(response);
        var AllAthleteList = response.data.data.athletes;
        console.log(AllAthleteList);
        this.setState({ AllAthleteList });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  render() {
    return (
      <div className="content">
        <SuperAdminDashboard></SuperAdminDashboard>
        <div className="content-layout p-0">
          {/* <div className="clear10"></div> */}
          <div className="container">
            <div className="row">
              <div className="col-6 col-sm-6 col-md-12 col-lg-12 top-strip pt-28">
                <span className="fs-24 black bold">SCHOOLS </span>
                <img src={backArrow} alt="back"></img>
                <span className="fs-22 black bold">
                  {" "}
                  Alabama Crimson Tide football
                </span>
                <img src={backArrow} alt="back"></img>
                <span className="fs-22 black bold"> Athletes</span>
              </div>
            </div>
          </div>
          <div className="clear20"></div>

          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <MaterialTable
              title=""
              data={this.state.AllAthleteList}
              columns={columns}
              options={{
                filtering: true,
                selection: true,
                headerStyle: { fontFamily: "Rajdhani-Bold", fontSize: 14 },
                rowStyle: { fontSize: 17, fontFamily: "Rajdhani-SemiBold" },
                // rowStyle: rowData => ({ backgroundColor: rowData.tableData.checked ? '#37b15933' : '' }),
                // paging:true,
                pageSize: 20,
                // emptyRowsWhenPaging: true,
                // pageSizeOptions:[20,40,60,80,100],
              }}
            ></MaterialTable>
          </div>
        </div>
      </div>
    );
  }
}

export default Schools;
